export default "__VITE_ASSET__629771ae__"